<template>
  <div class="container-fluid mt-6">
    <card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
      <div class="row">
        <!-- <router-link
          v-if="$currentUserCan($permissions.PERM_VIEW_MODULE_OPTIONS)"
          :to="{ name: 'List Options' }"
          class="col-4 shortcut-item"
          v-slot="{ href, navigate }"
          custom
        >
          <a :href="href" @click="navigate">
            <span
              class="shortcut-media avatar avatar-xl rounded-circle bg-info"
            >
              <i class="ni ni-2x ni-map-big"></i>
            </span>
            <small>{{ $t("COMMON.OPTIONS") }}</small>
          </a>
        </router-link> -->
        <router-link
          v-if="$currentUserIsLevelAdmin"
          :to="{ name: 'List Clients' }"
          class="col-4 shortcut-item"
          v-slot="{ href, navigate }"
          custom
        >
          <a :href="href" @click="navigate">
            <span
              class="shortcut-media avatar avatar-xl rounded-circle bg-info"
            >
              <i class="fa-regular fa-2x fa-map"></i>
            </span>
            <small>{{ $t("COMMON.CLIENTS") }}</small>
          </a>
        </router-link>
        <router-link
          v-if="$currentUserIsLevelAdmin"
          :to="{ name: 'List Users' }"
          class="col-4 shortcut-item"
          v-slot="{ href, navigate }"
          custom
        >
          <a :href="href" @click="navigate">
            <span
              class="shortcut-media avatar avatar-xl rounded-circle bg-info"
            >
              <i class="fa-light fa-2x fa-users"></i>
            </span>
            <small>{{ $t("COMMON.USERS") }}</small>
          </a>
        </router-link>

      </div>
    </card>
  </div>
</template>

<script>
export default {
  layout: "DashboardLayout",

  components: {},

  mixins: [],

  data() {
    return {};
  },

  created() {},

  methods: {},
};
</script>
